import { render, staticRenderFns } from "./discussionindex.vue?vue&type=template&id=786dc883&scoped=true"
import script from "./discussionindex.vue?vue&type=script&lang=js"
export * from "./discussionindex.vue?vue&type=script&lang=js"
import style0 from "./discussionindex.vue?vue&type=style&index=0&id=786dc883&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786dc883",
  null
  
)

export default component.exports